import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Context } from '../shared/services/context.service';

@Injectable({
  providedIn: 'root'
})
export class PlanDeTraitementService {

  constructor(private http: HttpClient,
    private context: Context,) { }
  private httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });


  getPlanDeTraitement(id) {
    return this.http.get<any>(Context.apiUrl + 'getPlanDeTraitement/' + id);
  }

  getAllPlanDeTraitement(id) {
    return this.http.get<any>(Context.apiUrl + 'all-treatments/' + id);
  }

  updateCommentAligneur(id: number, comment: string) {
    return this.http.put<any>(
      `${Context.apiUrl}updateCommentAligneur/${id}?comment=${encodeURIComponent(comment)}`,
      {} // body vide car on passe le paramètre dans l'URL
    );
  }

  setPlanDeTraitement(plandetraitement) {
    return this.http.post(Context.apiUrl + 'savePlanDeTraitement/', plandetraitement);
  }

  getListPlanDeTraitements(idPatient) {
    return this.http.get(Context.apiUrl + 'getListPlanDeTraitements/' + idPatient);
  }

  deletePlanDeTraitement(idPatient) {
    return this.http.delete(Context.apiUrl + 'deletePlanDeTraitement/', idPatient);
  }

  /**
   * Update meta status (ADMIN action)
   */
  updateTreatmentPlanStatus(id: number, status: 'RECU' | 'ANNULER' | 'EN_COURS' | 'EXPEDIER') {
    return this.http.put(`${Context.apiUrl}treatment-plan-meta/${id}/status`, { status });
  }

  /**
   * Update meta commentaire (STARTUP / LABO action)
   */
  updateTreatmentPlanCommentaire(id: number, commentaire: string) {
    return this.http.put(`${Context.apiUrl}treatment-plan-meta/${id}/commentaire`, { commentaire });
  }
}